import React from 'react';
import { Link } from 'react-router-dom';
import {
  BookOpen,
  Users,
  Award,
  Clock,
  Star,
  Play,
  ArrowRight,
  TrendingUp,
  Globe,
  Shield,
  Zap
} from 'lucide-react';

const HeroIllustration = () => (
  <div className="relative w-full select-none" style={{ maxWidth: '640px', margin: '0 auto' }}>
    <style>{`
      @keyframes hiFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
      @keyframes hiFloat2{0%,100%{transform:translateY(0)}50%{transform:translateY(-13px)}}
      @keyframes hiPulse{0%,100%{opacity:.25}50%{opacity:.8}}
      .hi-f1{animation:hiFloat 4s ease-in-out infinite}
      .hi-f2{animation:hiFloat2 5s ease-in-out infinite .7s}
      .hi-f3{animation:hiFloat 4.5s ease-in-out infinite 1.4s}
      .hi-f4{animation:hiFloat2 5.5s ease-in-out infinite 2.1s}
      .hi-p{animation:hiPulse 3s ease-in-out infinite}
      .hi-p2{animation:hiPulse 3s ease-in-out infinite 1s}
      .hi-p3{animation:hiPulse 3s ease-in-out infinite 2s}
    `}</style>
    <svg viewBox="0 0 480 380" xmlns="http://www.w3.org/2000/svg"
         className="w-full h-auto drop-shadow-xl" style={{ overflow: 'visible' }}>
      <defs>
        <linearGradient id="hiVidGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1d4ed8" stopOpacity=".7"/>
          <stop offset="100%" stopColor="#7c3aed" stopOpacity=".7"/>
        </linearGradient>
      </defs>

      {/* Background decorative circles */}
      <circle cx="430" cy="50" r="70" fill="rgba(255,255,255,0.04)"/>
      <circle cx="55" cy="320" r="50" fill="rgba(255,255,255,0.04)"/>

      {/* ── LAPTOP BODY ── */}
      <rect x="90" y="48" width="300" height="220" rx="14" fill="#1e293b"/>
      {/* Screen */}
      <rect x="102" y="60" width="276" height="196" rx="8" fill="#0f172a"/>

      {/* Screen header bar */}
      <rect x="102" y="60" width="276" height="26" rx="8" fill="#1e3a5f"/>
      <circle cx="119" cy="73" r="4.5" fill="#ef4444"/>
      <circle cx="134" cy="73" r="4.5" fill="#f59e0b"/>
      <circle cx="149" cy="73" r="4.5" fill="#22c55e"/>
      <text x="240" y="77" textAnchor="middle" fill="rgba(255,255,255,.55)"
            fontSize="7.5" fontFamily="ui-sans-serif,system-ui,sans-serif">
        Innovactive360° — Mon cours
      </text>

      {/* Video thumbnail */}
      <rect x="110" y="93" width="152" height="96" rx="7" fill="#1e3a8a"/>
      <rect x="110" y="93" width="152" height="96" rx="7" fill="url(#hiVidGrad)"/>
      <circle cx="186" cy="141" r="18" fill="rgba(255,255,255,.12)"/>
      <circle cx="186" cy="141" r="13" fill="rgba(255,255,255,.18)"/>
      <polygon points="182,134 182,148 196,141" fill="white"/>

      {/* Right panel: course info */}
      <rect x="271" y="97" width="98" height="7" rx="3.5" fill="#3b82f6"/>
      <rect x="271" y="110" width="82" height="5" rx="2.5" fill="rgba(255,255,255,.28)"/>
      <rect x="271" y="121" width="94" height="5" rx="2.5" fill="rgba(255,255,255,.28)"/>
      <rect x="271" y="132" width="68" height="5" rx="2.5" fill="rgba(255,255,255,.18)"/>

      {/* Instructor avatar */}
      <circle cx="278" cy="155" r="8" fill="#7c3aed"/>
      <text x="278" y="158.5" textAnchor="middle" fill="white" fontSize="6.5"
            fontFamily="ui-sans-serif,system-ui,sans-serif" fontWeight="bold">JD</text>
      <rect x="291" y="150" width="54" height="4" rx="2" fill="rgba(255,255,255,.28)"/>
      <rect x="291" y="157" width="42" height="4" rx="2" fill="rgba(255,255,255,.18)"/>

      {/* Star rating */}
      <text x="271" y="178" fill="#fbbf24" fontSize="9"
            fontFamily="ui-sans-serif,system-ui,sans-serif">★★★★★</text>
      <text x="319" y="178" fill="rgba(255,255,255,.5)" fontSize="7.5"
            fontFamily="ui-sans-serif,system-ui,sans-serif"> 4.9</text>

      {/* Progress bar */}
      <text x="110" y="200" fill="rgba(255,255,255,.4)" fontSize="6.5"
            fontFamily="ui-sans-serif,system-ui,sans-serif" letterSpacing="0.5">
        PROGRESSION DU COURS
      </text>
      <rect x="110" y="205" width="256" height="7" rx="3.5" fill="rgba(255,255,255,.1)"/>
      <rect x="110" y="205" width="166" height="7" rx="3.5" fill="#22c55e"/>
      <text x="372" y="212" textAnchor="end" fill="#22c55e" fontSize="7.5"
            fontFamily="ui-sans-serif,system-ui,sans-serif" fontWeight="bold">65%</text>

      {/* Chapter list */}
      <circle cx="118" cy="222" r="5.5" fill="#22c55e"/>
      <text x="128" y="225.5" fill="rgba(255,255,255,.82)" fontSize="7"
            fontFamily="ui-sans-serif,system-ui,sans-serif">Introduction au cours</text>
      <circle cx="118" cy="236" r="5.5" fill="#22c55e"/>
      <text x="128" y="239.5" fill="rgba(255,255,255,.82)" fontSize="7"
            fontFamily="ui-sans-serif,system-ui,sans-serif">Fondamentaux et concepts</text>
      <circle cx="118" cy="250" r="5.5" fill="none" stroke="rgba(255,255,255,.3)" strokeWidth="1.5"/>
      <text x="128" y="253.5" fill="rgba(255,255,255,.4)" fontSize="7"
            fontFamily="ui-sans-serif,system-ui,sans-serif">Projets pratiques</text>

      {/* ── LAPTOP BASE ── */}
      <rect x="62" y="270" width="356" height="13" rx="6.5" fill="#334155"/>
      <rect x="174" y="283" width="132" height="8" rx="4" fill="#475569"/>

      {/* ── FLOATING CARD 1: Satisfaction (top-right) ── */}
      <g className="hi-f1">
        <rect x="386" y="22" width="87" height="68" rx="12"
              fill="rgba(251,191,36,.12)" stroke="rgba(251,191,36,.45)" strokeWidth="1.2"/>
        <rect x="415" y="32" width="26" height="17" rx="3"
              fill="none" stroke="#fbbf24" strokeWidth="2"/>
        <path d="M415 38 Q407 38 407 32 L415 32" stroke="#fbbf24" strokeWidth="1.5" fill="none"/>
        <path d="M441 38 Q449 38 449 32 L441 32" stroke="#fbbf24" strokeWidth="1.5" fill="none"/>
        <rect x="426" y="49" width="4" height="6" fill="#fbbf24"/>
        <rect x="420" y="55" width="16" height="3" rx="1.5" fill="#fbbf24"/>
        <text x="429.5" y="71" textAnchor="middle" fill="white" fontSize="9"
              fontFamily="ui-sans-serif,system-ui,sans-serif" fontWeight="bold">95%</text>
        <text x="429.5" y="81" textAnchor="middle" fill="rgba(255,255,255,.6)" fontSize="6.5"
              fontFamily="ui-sans-serif,system-ui,sans-serif">Satisfaction</text>
      </g>

      {/* ── FLOATING CARD 2: Cours (top-left) ── */}
      <g className="hi-f2">
        <rect x="7" y="52" width="83" height="68" rx="12"
              fill="rgba(99,102,241,.15)" stroke="rgba(99,102,241,.5)" strokeWidth="1.2"/>
        <rect x="22" y="62" width="13" height="20" rx="2" fill="#6366f1"/>
        <rect x="23" y="63" width="11" height="18" rx="1" fill="#818cf8"/>
        <rect x="36" y="62" width="13" height="20" rx="2" fill="#6366f1"/>
        <line x1="36" y1="62" x2="36" y2="82" stroke="#4338ca" strokeWidth="1"/>
        <rect x="50" y="65" width="11" height="16" rx="2" fill="#6366f1" opacity="0.7"/>
        <text x="48.5" y="96" textAnchor="middle" fill="white" fontSize="9"
              fontFamily="ui-sans-serif,system-ui,sans-serif" fontWeight="bold">500+</text>
        <text x="48.5" y="107" textAnchor="middle" fill="rgba(255,255,255,.6)" fontSize="6.5"
              fontFamily="ui-sans-serif,system-ui,sans-serif">Cours</text>
      </g>

      {/* ── FLOATING CARD 3: Étudiants (bottom-left) ── */}
      <g className="hi-f3">
        <rect x="7" y="258" width="86" height="68" rx="12"
              fill="rgba(34,197,94,.12)" stroke="rgba(34,197,94,.45)" strokeWidth="1.2"/>
        <circle cx="37" cy="275" r="8" fill="#22c55e" opacity="0.8"/>
        <path d="M24 296 Q24 287 37 287 Q50 287 50 296" fill="#22c55e" opacity="0.8"/>
        <circle cx="53" cy="273" r="7" fill="#16a34a"/>
        <path d="M41 296 Q41 288 53 288 Q65 288 65 296" fill="#16a34a"/>
        <text x="50" y="311" textAnchor="middle" fill="white" fontSize="9"
              fontFamily="ui-sans-serif,system-ui,sans-serif" fontWeight="bold">10K+</text>
        <text x="50" y="321" textAnchor="middle" fill="rgba(255,255,255,.6)" fontSize="6.5"
              fontFamily="ui-sans-serif,system-ui,sans-serif">Étudiants</text>
      </g>

      {/* ── FLOATING CARD 4: Note moyenne (bottom-right) ── */}
      <g className="hi-f4">
        <rect x="386" y="252" width="87" height="68" rx="12"
              fill="rgba(249,115,22,.12)" stroke="rgba(249,115,22,.45)" strokeWidth="1.2"/>
        <polygon
          points="429.5,262 432.3,271 442,271 434.5,276.5 437.3,285.5 429.5,280 421.7,285.5 424.5,276.5 417,271 426.7,271"
          fill="#fb923c"/>
        <text x="429.5" y="300" textAnchor="middle" fill="white" fontSize="9"
              fontFamily="ui-sans-serif,system-ui,sans-serif" fontWeight="bold">4.9 / 5</text>
        <text x="429.5" y="310" textAnchor="middle" fill="rgba(255,255,255,.6)" fontSize="6.5"
              fontFamily="ui-sans-serif,system-ui,sans-serif">Note moyenne</text>
      </g>

      {/* Decorative animated dots */}
      <circle className="hi-p" cx="462" cy="165" r="3.5" fill="rgba(255,255,255,.3)"/>
      <circle className="hi-p2" cx="470" cy="185" r="2.5" fill="rgba(255,255,255,.2)"/>
      <circle className="hi-p3" cx="458" cy="205" r="2" fill="rgba(255,255,255,.15)"/>
      <circle className="hi-p2" cx="15" cy="165" r="3" fill="rgba(255,255,255,.25)"/>
      <circle className="hi-p3" cx="7" cy="188" r="2" fill="rgba(255,255,255,.15)"/>
      <circle className="hi-p" cx="19" cy="210" r="2.5" fill="rgba(255,255,255,.2)"/>
    </svg>
  </div>
);

const Home = () => {
  const stats = [
    { icon: Users, value: '10,000+', label: 'Étudiants actifs' },
    { icon: BookOpen, value: '500+', label: 'Cours disponibles' },
    { icon: Award, value: '95%', label: 'Taux de satisfaction' },
    { icon: Clock, value: '24/7', label: 'Support disponible' },
  ];

  const features = [
    {
      icon: Globe,
      title: 'Apprentissage flexible',
      description: 'Apprenez à votre rythme, où que vous soyez, sur tous vos appareils.'
    },
    {
      icon: Shield,
      title: 'Certification reconnue',
      description: 'Obtenez des certificats accrédités reconnus par l\'industrie.'
    },
    {
      icon: Zap,
      title: 'Contenu interactif',
      description: 'Vidéos, quiz, exercices pratiques et projets concrets.'
    },
    {
      icon: TrendingUp,
      title: 'Suivi des progrès',
      description: 'Visualisez vos progrès et identifiez vos points d\'amélioration.'
    }
  ];

  const popularCategories = [
    { name: 'Développement Web', count: 45, color: 'bg-blue-500' },
    { name: 'Data Science', count: 32, color: 'bg-green-500' },
    { name: 'Marketing Digital', count: 28, color: 'bg-purple-500' },
    { name: 'Design UX/UI', count: 25, color: 'bg-pink-500' },
    { name: 'Business', count: 22, color: 'bg-orange-500' },
    { name: 'Langues', count: 18, color: 'bg-red-500' },
  ];

  const testimonials = [
    {
      name: 'Marie Dubois',
      role: 'Développeuse Full-Stack',
      content: 'Grâce à Innovactive360°, j\'ai pu me reconvertir professionnellement en seulement 6 mois. Les cours sont excellents !',
      rating: 5,
      avatar: 'MD'
    },
    {
      name: 'Thomas Martin',
      role: 'Chef de projet',
      content: 'La qualité des formations et le support sont exceptionnels. Je recommande vivement cette plateforme.',
      rating: 5,
      avatar: 'TM'
    },
    {
      name: 'Sophie Bernard',
      role: 'Designer UX',
      content: 'Une expérience d\'apprentissage moderne et engageante. Les projets pratiques m\'ont beaucoup aidée.',
      rating: 5,
      avatar: 'SB'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-white overflow-hidden">
        {/* Dot pattern — top right */}
        <div className="hidden sm:block absolute top-6 right-6 pointer-events-none" style={{ opacity: 0.25 }}>
          <svg width="130" height="110" viewBox="0 0 130 110">
            {[0,1,2,3,4].map(row => [0,1,2,3,4,5].map(col => (
              <circle key={`${row}-${col}`} cx={col * 22 + 11} cy={row * 22 + 11} r="2.5" fill="#004D99"/>
            )))}
          </svg>
        </div>
        {/* Dot pattern — bottom right */}
        <div className="hidden md:block absolute bottom-16 right-6 pointer-events-none" style={{ opacity: 0.18 }}>
          <svg width="90" height="90" viewBox="0 0 90 90">
            {[0,1,2,3].map(row => [0,1,2,3].map(col => (
              <circle key={`${row}-${col}`} cx={col * 22 + 11} cy={row * 22 + 11} r="2.5" fill="#B8001F"/>
            )))}
          </svg>
        </div>
        {/* Bottom-left red arc accent */}
        <div
          className="absolute bottom-0 left-0 w-40 h-28 pointer-events-none"
          style={{ background: '#B8001F', borderTopRightRadius: '100%', opacity: 0.9 }}
        />

        <style>{`
          @keyframes hiBubble{0%,100%{transform:translateY(0)}50%{transform:translateY(-9px)}}
          .hi-b1{animation:hiBubble 4s ease-in-out infinite}
          .hi-b2{animation:hiBubble 5s ease-in-out infinite 1s}
          .hi-b3{animation:hiBubble 4.5s ease-in-out infinite 2s}
        `}</style>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center" style={{ minHeight: 'clamp(0px, 40vw, 560px)' }}>

            {/* LEFT: text content */}
            <div className="flex-1 py-16 lg:py-24 z-10 text-center lg:text-left">
              <h1
                className="font-bold leading-tight mb-1"
                style={{ color: '#002147', fontSize: 'clamp(2.2rem, 4.5vw, 3.6rem)' }}
              >
                Transformez votre<br/>avenir avec
              </h1>
              <h1
                className="font-bold leading-tight mb-5"
                style={{ color: '#B8001F', fontSize: 'clamp(2.2rem, 4.5vw, 3.6rem)' }}
              >
                Innovactive360°
              </h1>
              <div className="mb-7 mx-auto lg:mx-0" style={{ width: '52px', height: '4px', background: '#B8001F', borderRadius: '2px' }}/>
              <p className="text-gray-500 text-lg mb-10 mx-auto lg:mx-0 leading-relaxed" style={{ maxWidth: '420px' }}>
                Découvrez notre plateforme MOOC révolutionnaire avec des cours de qualité,
                des experts reconnus et une expérience d'apprentissage personnalisée.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <Link
                  to="/courses"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-xl font-semibold text-base text-white transition-opacity hover:opacity-90"
                  style={{ background: '#B8001F' }}
                >
                  <Play className="w-4 h-4"/> Commencer à apprendre
                </Link>
                <Link
                  to="/register"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-xl font-semibold text-base border-2 transition-colors hover:bg-blue-50"
                  style={{ color: '#004D99', borderColor: '#004D99' }}
                >
                  <Users className="w-4 h-4"/> S'inscrire gratuitement
                </Link>
              </div>
            </div>

            {/* RIGHT: circles + illustration + floating icons */}
            <div className="relative flex-1 flex items-center justify-center w-full lg:min-h-0" style={{ minHeight: 'clamp(280px, 50vw, 520px)' }}>
              {/* Light gray circle (background) — hidden on small screens */}
              <div
                className="hidden lg:block absolute rounded-full pointer-events-none"
                style={{ width: '500px', height: '500px', background: 'rgba(200,215,235,0.35)', top: '-30px', right: '-90px' }}
              />
              {/* Red circle — hidden on small screens */}
              <div
                className="hidden lg:block absolute rounded-full pointer-events-none"
                style={{ width: '380px', height: '380px', background: '#B8001F', top: '20px', right: '-50px' }}
              />
              {/* Blue circle — hidden on small screens */}
              <div
                className="hidden lg:block absolute rounded-full pointer-events-none"
                style={{ width: '310px', height: '310px', background: '#004D99', top: '75px', right: '15px' }}
              />

              {/* Laptop illustration */}
              <div className="relative z-10 w-full" style={{ maxWidth: 'clamp(260px, 80vw, 430px)' }}>
                <HeroIllustration />
              </div>

              {/* Floating icon: graduation cap — hidden on small screens */}
              <div
                className="hi-b1 hidden lg:flex absolute z-20 items-center justify-center rounded-full"
                style={{ top: '80px', left: '70px', width: '62px', height: '62px', background: '#B8001F', boxShadow: '0 8px 24px rgba(184,0,31,0.35)' }}
              >
                <Award className="w-7 h-7 text-white"/>
              </div>
              {/* Floating icon: play — hidden on small screens */}
              <div
                className="hi-b2 hidden lg:flex absolute z-20 items-center justify-center rounded-full"
                style={{ top: '250px', left: '35px', width: '54px', height: '54px', background: '#004D99', boxShadow: '0 8px 24px rgba(0,77,153,0.35)' }}
              >
                <Play className="w-5 h-5 text-white"/>
              </div>
              {/* Floating icon: users — hidden on small screens */}
              <div
                className="hi-b3 hidden lg:flex absolute z-20 items-center justify-center rounded-full"
                style={{ top: '155px', right: '-5px', width: '54px', height: '54px', background: '#004D99', boxShadow: '0 8px 24px rgba(0,77,153,0.35)' }}
              >
                <Users className="w-5 h-5 text-white"/>
              </div>
            </div>
          </div>

          {/* Feature cards */}
          <div className="pb-10 flex justify-center lg:justify-end">
            <div
              className="flex flex-col sm:flex-row bg-white rounded-2xl overflow-hidden"
              style={{ boxShadow: '0 4px 40px rgba(0,0,0,0.10)', maxWidth: '780px' }}
            >
              {[
                { Icon: BookOpen, color: '#B8001F', title: 'Cours de qualité', desc: 'Des contenus conçus par des experts dans leur domaine' },
                { Icon: Users, color: '#004D99', title: 'Experts reconnus', desc: 'Apprenez auprès de professionnels expérimentés' },
                { Icon: TrendingUp, color: '#B8001F', title: 'Apprentissage personnalisé', desc: 'Progressez à votre rythme selon vos objectifs' },
              ].map(({ Icon, color, title, desc }, i) => (
                <div
                  key={title}
                  className={`flex items-start gap-3 p-5 flex-1 ${i < 2 ? 'sm:border-r border-gray-100' : ''}`}
                >
                  <div
                    className="w-10 h-10 rounded-lg flex-shrink-0 flex items-center justify-center"
                    style={{ background: color }}
                  >
                    <Icon className="w-5 h-5 text-white"/>
                  </div>
                  <div>
                    <h3 className="font-bold text-sm mb-1" style={{ color }}>{title}</h3>
                    <p className="text-gray-400 text-xs leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={stat.label} className="text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <stat.icon className="w-8 h-8 text-primary" />
                </div>
                <div className="text-3xl font-bold text-text mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-text mb-4">
              Pourquoi choisir Innovactive360° ?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Notre plateforme combine innovation technologique et excellence pédagogique 
              pour vous offrir la meilleure expérience d'apprentissage possible.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={feature.title} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-text mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Categories */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-text mb-4">
              Catégories populaires
            </h2>
            <p className="text-xl text-gray-600">
              Explorez nos domaines d'expertise les plus demandés
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {popularCategories.map((category, index) => (
              <div key={category.name} className="text-center group cursor-pointer">
                <div className={`w-16 h-16 ${category.color} rounded-lg flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-200`}>
                  <BookOpen className="w-8 h-8 text-white" />
                </div>
                <h3 className="font-medium text-text mb-1">{category.name}</h3>
                <p className="text-sm text-gray-500">{category.count} cours</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-text mb-4">
              Ce que disent nos étudiants
            </h2>
            <p className="text-xl text-gray-600">
              Découvrez les témoignages de ceux qui ont transformé leur carrière
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={testimonial.name} className="bg-white p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-semibold mr-3">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <h4 className="font-semibold text-text">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-gray-600 mb-4">{testimonial.content}</p>
                <div className="flex items-center">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Prêt à transformer votre avenir ?
          </h2>
          <p className="text-xl mb-8 text-gray-100">
            Rejoignez des milliers d'étudiants qui ont déjà commencé leur voyage 
            vers le succès avec Innovactive360°.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/register"
              className="bg-white text-primary px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors duration-200 flex items-center justify-center space-x-2"
            >
              <span>Commencer maintenant</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/courses"
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-primary transition-colors duration-200"
            >
              Explorer les cours
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
